import loadable from '@loadable/component';
import { Navigate } from 'react-router';
import { OverlaySpinner } from '@ankr.com/ui';

import { LoggingInGuard } from 'modules/auth/components/LoggingInGuard';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { Page } from 'modules/layout/components/Page';
import { RedirectToAuthPage } from 'modules/auth/components/RedirectToAuthPage';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { selectIsSignedOutManually } from 'modules/auth/store/selectors';
import { useAppSelector } from 'store/useAppSelector';

import { useHomePageStyles } from './useHomePageStyles';

const HomePage = loadable(
  () => import('./HomePage').then(module => module.HomePage),
  {
    fallback: <OverlaySpinner />,
  },
);

const chainsList = chainsRoutesConfig.chains.generatePath();

export const HomePageContainer = () => {
  const isSignedOutManually = useAppSelector(selectIsSignedOutManually);

  const { classes } = useHomePageStyles();

  return (
    <Page
      className={classes.root}
      classes={{ suspendedUserAlert: classes.suspendedUserAlert }}
    >
      <NoSSRGuard>
        <LoggingInGuard
          fallback={
            isSignedOutManually ? (
              <Navigate to={chainsList} />
            ) : (
              <RedirectToAuthPage />
            )
          }
        >
          <HomePage />
        </LoggingInGuard>
      </NoSSRGuard>
    </Page>
  );
};
